import './origins.scss';

import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider
    .when('/origins', {
        template: require('./origins.html'),
        controller: 'OriginsController',
        controllerAs: '$ctrl'
    });
})
.controller('OriginsController', function(Origin, $modal, $scope, $timeout, $http, $q, $location, $window){
    "ngInject"

    $scope.newAdminURL = NEW_ADMIN_URL;

    const UNHEALTHY_TRANSCODE_DELAY_LIMIT_S = 60;

    // Default filter: ready and draining
    this.f = {
        status: {
            stopped: false,
            starting: false,
            ready: true,
            draining: true,
            stopping: false,
            failed: false,
        },
    };

    // Try loading it from the search, if present
    const locationF = $location.search().f;
    if (locationF) {
        try {
            this.f = JSON.parse(decodeURIComponent(locationF));
        } catch (err) {
            console.error("Error parsing search parameter f", err);
        }
    }

    this.filter = (key, val) => {
        const keyParts = key.split('.');
        let currentFilter = this.f;
        while (keyParts.length > 1) currentFilter = currentFilter[keyParts.shift()];
        currentFilter[keyParts[0]] = val;
        $location.search('f', encodeURIComponent(JSON.stringify(this.f)));
        applyFilter();
    }

    const applyFilter = () => {
        let filteredOrigins = [];
        this.allOrigins.forEach((origin) => {
            let included = true;
            for (const [key, value] of Object.entries(this.f)) {
                if (!value[origin[key]]) {
                    included = false;
                    break;
                }
            }
            if (included) {
                filteredOrigins.push(origin)
            }
        });
        this.origins = _.sortBy(filteredOrigins, 'name');
    };

    this.maxTranscodeDelay = (origin) => {
        if (_.isEmpty(origin.broadcasts)) {
            return 0;
        }
        return _.max(_.map(origin.broadcasts, (broadcast) => {
            return parseFloat((broadcast.stream_diagnostics || {}).last_transcode_delay || 0);
        }));
    };

    this.originIsUnhealthy = (origin) => this.maxTranscodeDelay(origin) > UNHEALTHY_TRANSCODE_DELAY_LIMIT_S;

    this.totalViewerCount = (origin) => _.reduce(_.map(origin.broadcasts, b => b.total_active_viewer_count), (m, n) => m + n, 0);

    this.terminate = (origin) => {
        $modal.open({
          template: require('./confirm_termination.html'),
          controller: 'ConfirmTerminationController',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            broadcast_count: () => origin.broadcasts.length,
            origin: () => origin.name,
            total_viewer_count: () => this.totalViewerCount(origin),
          }
        }).result.finally(() => load());
    }

    this.drain = (origin) => {
        if ($window.confirm(`Are you sure you wish to drain origin "${origin.name}"?`)) {
            Origin.drain(
                { id: origin.name },
                {},
                () => {},
                (err) => {
                    console.error(err);
                    alert('There was an error draining the origin.');
                }
            ).$promise.finally(load);
        }
    }

    const load = () => {
        return Origin.query(
            {}, // no query params
            data => {
                this.allOrigins = data;
                applyFilter();
            },
            err => {
                console.error(err);
                alert('There was an error loading origins. Please reload the page.');
            }
        );
    }
    this.loading = true;
    load().$promise.finally(() => this.loading = false);
});



// WEBPACK FOOTER //
// ./views/origins/origins_controller.js